import { type SynastryV2Response } from '@/api/schema/synastry'
import { Emoji } from '@/app/components/Emoji/Emoji'
import { Col, Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { Loader } from '@/app/components/Loader/Loader'
import { Motion } from '@/app/components/Motion/Motion'
import { UI } from '@/app/components/UI/UI'
import { useNavigate } from '@/app/hooks/useNavigate'
import { Compare } from '@/app/pages/SynastryPage/SynastryV2/Compare/Compare'
import { SynastryMain } from '@/app/pages/SynastryPage/SynastryV2/Main/SynastryMain'
import { api } from '@/app/utils/api'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useParams } from 'wouter-preact'

export const SynastrySharePage: FunctionalComponent = () => {
  const route = useNavigate()

  const params = useParams<{ id: string; type: string }>()
  const [data, setData] = useState<SynastryV2Response | null>(null)

  const fetchData = async () => {
    setData(null)

    api.get<SynastryV2Response>(`/synastry2/share/${params.id}`)
      .then(r => {
        setData(r.data)
      })
  }

  useEffect(() => {
    fetchData()
  }, [params.id])

  return (
    <Layout>
      <Layout.Content>
        {!data
          ? (
            <Loader.Container>
              <Loader type={params.type === 'astro' ? 'astro-synastry' : 'matrix-synastry'} />
            </Loader.Container>
          )
          : (
            <Motion>
              <Layout.Header>
                <Col alignItems='center' gap={4}>
                  {data.persone1Name}
                  <Emoji type='synastry' size={20} />
                  {data.persone2Name}
                </Col>
              </Layout.Header>

              <Row gap={15}>
                <SynastryMain
                  data={data}
                />

                <Compare
                  data={data}
                />

                <UI.Button
                  size='l'
                  type='primary'
                  onClick={() => {
                    route('~/tools/synastry')
                  }}
                >
                  Создать свой разбор
                </UI.Button>
              </Row>
            </Motion>
          )}
      </Layout.Content>
    </Layout>
  )
}
